import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
// import {Observable} from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx'
import { catchError, tap } from 'rxjs/operators'
import { apiUrl, baseUrl, imageStatusUrl, mergeDeep } from '../../helper/common'
import { Subject } from 'rxjs/Subject'
import { Router } from '@angular/router'

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
}

const API_URL = apiUrl + '/'
const IMAGE_URL = apiUrl + '/'

@Injectable()
export class RestServices {
    private total: Response

    private emitLoading = new Subject<boolean>()
    // Observable string streams
    loadingEmitted$ = this.emitLoading.asObservable()

    constructor(private http: HttpClient, private router: Router) {
    }

    makeResourceObject(params) {
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }

        return mergeDeep(resourceData, params)
    }
    
    makeResourceObjectWithOutDeleted(params) {
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    }
                },
            },
        }
        return mergeDeep(resourceData, params)
    }
    httpHeadersToken(token) {
        const bearerToken = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ JSON.parse(token) }`,
            }),
        }
        return bearerToken
    }

    httpHeadersTokenCookie(token) {
        const cookieToken = {
            headers: new HttpHeaders({ Cookie: `token=${ JSON.parse(token) }` }),
        }
        return cookieToken
    }

    // HTTP POST
    http_post(Path, bodyResource: any, tokenResource = null): Observable<object> {
        console.log('http post', bodyResource)
        return this.http.post<any>(API_URL + Path, bodyResource, (tokenResource) ? this.httpHeadersToken(tokenResource) : httpOptions).pipe(
            tap( // Log the result or error
                (response: Response) => {
                    return response
                },
                error => this.logError(error),
            ),
        )
    }

    post(Path: string, bodyResource: any): Observable<any> {
        return this.http.post<any>(Path, bodyResource).pipe(tap( // Log the result or error
            (response: Response) => {
                return response
            }, error => this.logError(error)))
    }

    // HTTP PUT
    http_put(Path, bodyResource: any, tokenResource = null): Observable<object> {
        return this.http.put<any>(API_URL + Path, bodyResource, (tokenResource) ? this.httpHeadersToken(tokenResource) : httpOptions).pipe(
            tap( // Log the result or error
                (response: Response) => {
                    return response
                },
                error => this.logError(error),
            ),
        )
    }

    // HTTP GET
    http_get(path, tokenResource, keyToken = null): Observable<object> {
        switch (keyToken) {
            case 'getTokenCookie':
                return this.http.get(this.prettyPath(path), this.httpHeadersTokenCookie(tokenResource)).pipe(
                    tap( // Log the result or error
                        (response: Response) => {
                            return response
                        },
                        error => this.logError(error),
                    ),
                )
            default:
                return this.http.get(this.prettyPath(path), (tokenResource) ? this.httpHeadersToken(tokenResource) : httpOptions).pipe(
                    tap( // Log the result or error
                        (response: Response) => {
                            return response
                        },
                        error => this.logError(error),
                    ),
                )
        }
    }

    prettyPath(path) {
        if (path[0] == '/') {
            path = path.substr(1)
        }
        if (path.includes('http')) {
            return path
        }
        return baseUrl + path
    }

    // HTTP DELETE
    http_delete(Path: string, id: number): Observable<{}> {
        const url = `${ API_URL + Path }/${ id }` // DELETE api/heroes/42
        return this.http.delete(url, httpOptions)
    }

    http_get_csv(url): Observable<any> {
        return this.http.get(url, { responseType: 'text' }).pipe(catchError((error: any) => Observable.throw(error)))
    }

    postFile(fileToUpload: File, tokenUpload): Observable<object> {
        const uploadPath = 'image/create'
        const httpOptionsUpload = {
            headers: new HttpHeaders({ 'Authorization': `Bearer ${ JSON.parse(tokenUpload) }` }),
        }
        const formData: FormData = new FormData()
        let fileName = fileToUpload && fileToUpload.name ? fileToUpload.name : ''
        formData.append('file', fileToUpload, fileName)
        return this.http.post(IMAGE_URL + uploadPath, formData, httpOptionsUpload).pipe(tap( // Log the result or error
            (response: Response) => {
                return response
            }, error => {
                return this.logError(error)
            }))
    }

    postCanvasImgs(Path: string, fileList, tokenUpload, canvasType): Observable<object> {
        if (JSON.stringify(fileList) != '{}') {
            const httpOptionsUpload = {
                headers: new HttpHeaders({ 'Authorization': `Bearer ${ JSON.parse(tokenUpload) }` }),
            }
            const imgDemo: FormData = new FormData()
            imgDemo.append('file', fileList.imgDemo, fileList.imgDemo.name)
            if (fileList.imgBase) {
                const imgBase: FormData = new FormData()
                imgBase.append('file', fileList.imgBase, fileList.imgBase.name)
                if (canvasType == 'dsd') {
                    const imgBefore: FormData = new FormData()
                    imgBefore.append('file', fileList.imgBefore, fileList.imgBefore.name)
                    return Observable.forkJoin(
                        this.http.post(API_URL + Path, imgBase, httpOptionsUpload),
                        this.http.post(API_URL + Path, imgDemo, httpOptionsUpload),
                        this.http.post(API_URL + Path, imgBefore, httpOptionsUpload),
                    )
                } else {
                    return Observable.forkJoin(
                        this.http.post(API_URL + Path, imgBase, httpOptionsUpload),
                        this.http.post(API_URL + Path, imgDemo, httpOptionsUpload),
                    )
                }
            } else {
                return Observable.forkJoin(
                    this.http.post(API_URL + Path, imgDemo, httpOptionsUpload),
                )
            }
        } else {
            return new Observable(observable => {
                observable.next(null)
            })
        }
    }

    public downloadFile(token, id, filename = null, callback = null) {
        this.http_get(imageStatusUrl + '/' + id, token).subscribe(success => {
            this.http.get(success['url'], { responseType: 'blob' as 'json' }).subscribe(
                (response: any) => {
                    const dataType = response.type
                    const binaryData = []
                    binaryData.push(response)
                    const downloadLink = document.createElement('a')
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }))
                    if (filename) {
                        downloadLink.setAttribute('download', filename)
                    }

                    if (typeof callback === 'function') {
                        callback()
                    }
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                },
            )
        })
    }

    setLoading(loading = false) {
        this.emitLoading.next(loading)
    }

    private logError(error: any) {
        if (error.status === 401) {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            localStorage.removeItem('timeout')
            this.router.navigateByUrl('/app/login')
        }

        return error.error.responseCode
    }

}



// WEBPACK FOOTER //
// ./src/app/services/rest.services.ts